@if (theme) {
  <div class="font-body bg-cover border-t {{ theme?.root }} {{topLevelClasses}}" [style]="theme?.bgImage">
    <div class="{{containerLevelClasses}} container {{ theme?.container }}">
      @if (data.componentTitle !== null && data.componentTitle?.length !== 0) {
        <div
          class="py-v-spacing sm:px-v-spacing max-w-container mx-auto wysiwyg multi-icon__title"
          [innerHTML]="data.componentTitle"
        ></div>
      }
      <div class="flex flex-wrap items-center xl:flex-nowrap xl:flex-row justify-center">
        @for (icon of data.iconList; track icon; let index = $index) {
          <div
            class="multi-icon__icon py-v-spacing flex justify-center {{ getColumnWidthClasses() }}"
          [ngClass]="{
            'sm:px-v-spacing max-w-container mx-auto': data.iconList.length === 1,
            'sm:px-v-spacing': data.iconList.length > 1
          }"
            >
            @if (icon.iconImage.length > 0) {
              <img
                width="154"
                height="108"
                [src]="icon.iconImage[0].url"
                [alt]="icon.iconImage[0].altText ? icon.iconImage[0].altText : ''"
                />
            }
          </div>
        }
      </div>
    </div>
  </div>
}
